import { ApiClient } from '../ApiClient.js';

export class UsersApiService {
    static async list({ page = 1, per_page = 50, search = null, role = null, status = null, sort_by = 'created_at', sort_order = 'desc' } = {}) {
        const params = { page, per_page, sort_by, sort_order };
        if (search) params.search = search;
        if (role) params.role = role;
        if (status) params.status = status;
        return ApiClient.get('/api/v1/users', params);
    }

    static async listRoles({ assignableOnly = false } = {}) {
        const params = assignableOnly ? { assignable_only: true } : undefined;
        return ApiClient.get('/api/v1/users/roles', params);
    }

    static async listAssignable({ includeIds = [] } = {}) {
        const params = {};
        if (includeIds?.length) {
            params.include_ids = includeIds.filter(Boolean).join(',');
        }
        return ApiClient.get('/api/v1/users/assignable', params);
    }

    static async listLookup() {
        return ApiClient.get('/api/v1/users/lookup');
    }

    static async getById(userId) {
        return ApiClient.get(`/api/v1/users/${encodeURIComponent(userId)}`);
    }

    static async getProfile() {
        return ApiClient.get('/api/v1/users/me');
    }

    static async updateProfile(payload) {
        return ApiClient.put('/api/v1/users/me', payload);
    }

    static async create(payload) {
        return ApiClient.post('/api/v1/users', payload);
    }

    static async update(userId, payload) {
        return ApiClient.put(`/api/v1/users/${encodeURIComponent(userId)}`, payload);
    }

    static async reassignRole(userId, role, { clearPermissionOverrides = false } = {}) {
        return ApiClient.put(`/api/v1/users/${encodeURIComponent(userId)}/role`, {
            role,
            clear_permission_overrides: !!clearPermissionOverrides,
        });
    }

    static async delete(userId) {
        return ApiClient.delete(`/api/v1/users/${encodeURIComponent(userId)}`);
    }

    static async getMe() {
        return ApiClient.get('/api/v1/auth/me');
    }

    static avatarUrl(userId) {
        if (!userId) return null;
        const base = ApiClient.getBaseUrl();
        return `${base}/api/v1/users/${encodeURIComponent(userId)}/avatar`;
    }

    static async uploadAvatar(file) {
        const form = new FormData();
        form.append('file', file);
        // ApiClient handles FormData without JSON Content-Type
        return ApiClient.request('PUT', '/api/v1/users/me/avatar', { body: form, headers: {} });
    }

    static async uploadAvatarForUser(userId, file) {
        const form = new FormData();
        form.append('file', file);
        return ApiClient.request('PUT', `/api/v1/users/${encodeURIComponent(userId)}/avatar`, { body: form, headers: {} });
    }

    static async deleteAvatar() {
        return ApiClient.delete('/api/v1/users/me/avatar');
    }

    static async deleteAvatarForUser(userId) {
        return ApiClient.delete(`/api/v1/users/${encodeURIComponent(userId)}/avatar`);
    }

    static async fetchAvatarBlob(userId, opts = {}) {
        if (!userId) return null;
        return ApiClient.fetchBlob(`/api/v1/users/${encodeURIComponent(userId)}/avatar`, opts);
    }

    static async fetchMyAvatarBlob(opts = {}) {
        return ApiClient.fetchBlob('/api/v1/users/me/avatar', opts);
    }
}
